import React, { useEffect } from 'react';
import { Table } from 'react-bootstrap';
import Select from 'react-select';
import Skeleton from 'react-loading-skeleton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faFilter, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { LoggedUserContext } from 'contexts/logged-user-context';
import lib from '../../helpers/lib';
import RepresentadaService from 'services/representada-service';
import RelatorioService from 'services/relatorio-service';

export default function RankingVendedoresVolume({ representadas }) {
  const mesInicialFiltro = new Date(),
    y = mesInicialFiltro.getFullYear(),
    m = mesInicialFiltro.getMonth();
  const dataFinalFiltro = new Date(y, m + 1, 0);

  const [isLoading, setIsLoading] = React.useState(true);
  const [vendedores, setVendedores] = React.useState([]);
  const [totalVendedores, setTotalVendedores] = React.useState([]);

  const [filter, setFilter] = React.useState({
    codigoPedido: '',
    representadaId: null,
    mes: m + 1,
    ano: y
  });

  const [loadedRepresentadas, setLoadedRepresentadas] = React.useState(false);

  useEffect(() => {
    (async () => {
      if (loadedRepresentadas) {
        getRankingVendedoresVolume();
      }
    })();
  }, [loadedRepresentadas]);

  useEffect(() => {
    (async () => {
      if (representadas && representadas.length > 0) {
        setFilter((prevFilter) => ({
          ...prevFilter,
          representadaId: representadas[0]?.value
        }));
        setLoadedRepresentadas(true);
      }
    })();
  }, [representadas]);

  useEffect(() => {
    (async () => {
      if (vendedores?.length > 0) {
        let vendedoresComValor = vendedores.filter((item) => item.volumeMediaAnual > 0);

        let vendedoresModel = {
          nome: ' ',
          volumeAnoAnterior: +vendedores
            .reduce((acc, item) => acc + item.volumeAnoAnterior, 0)
            .toFixed(2),
          volumeMesAnterior: +vendedores
            .reduce((acc, item) => acc + item.volumeMesAnterior, 0)
            .toFixed(2),
          volumeMediaAnual:
            +vendedores.reduce((acc, item) => acc + item.volumeMediaAnual, 0).toFixed(2) /
            vendedores.length,
          volumeMaximoMensal: Math.max(
            ...vendedores.map((item) => {
              return item.volumeMaximoMensal;
            })
          ),
          volumeFaturado: +vendedores
            .reduce((acc, item) => acc + item.volumeFaturado, 0)
            .toFixed(2),
          volumeMeta: +vendedores.reduce((acc, item) => acc + item.volumeMeta, 0).toFixed(2),
          volumeRealizado: +vendedores
            .reduce((acc, item) => acc + item.volumeRealizado, 0)
            .toFixed(2)
        };

        vendedoresModel.volumeRealizado =
          vendedoresModel.volumeFaturado - vendedoresModel.volumeMeta;

        vendedoresModel.porcentagemRealizado =
          vendedoresModel.volumeMeta != 0
            ? +((vendedoresModel.volumeFaturado / vendedoresModel.volumeMeta) * 100).toFixed(2)
            : 0;

        setTotalVendedores([vendedoresModel]);
      }
    })();
  }, [vendedores]);

  async function getRepresentadas() {
    const response = await RepresentadaService.selectListAsync();
    if (response?.data) {
      setFilter({ ...filter, representadaId: response?.data?.data[0]?.options[0]?.value });
    }
  }

  async function getRankingVendedoresVolume() {
    setIsLoading(true);

    let resultStatus = await RelatorioService.getRankingVendedoresVolume(filter);
    if (resultStatus.data) {
      setVendedores(resultStatus.data);
    }

    setIsLoading(false);
  }

  async function getExtratoRankingVendedoresVolume() {
    setIsLoading(true);

    let response = await RelatorioService.getExtratoRankingVendedoresVolume(filter);

    if (response?.data) {
      let fileName = `faturamento_ranking_vendedores_volume_${lib.getCurrentDateFilename()}.xlsx`;
      lib.downloadFile(response.data.data, fileName);
    }

    setIsLoading(false);
  }

  return (
    <div>
      {/* Filter ------------------------------------------------------------------------------ */}
      <div className="row filter-bar2 mb-5">
        <div className="col-lg-3">
          <label>Representada</label>
          <Select
            isClearable={false}
            // clearValue={() => {
            //   setFilter({ ...filter, representadaId: null });
            // }}
            styles={customControlStyles}
            placeholder="Selecione..."
            options={representadas}
            value={representadas?.find((x) => x.value === filter.representadaId)}
            onChange={(selectedValue) => {
              setFilter({ ...filter, representadaId: selectedValue?.value });
            }}
          />
        </div>

        <div className="col-lg-2">
          <label>Mês</label>
          <Select
            className="select-form-control"
            value={lib.selectListMeses?.find((item) => item.value === filter.mes)}
            options={lib.selectListMeses}
            isClearable={false}
            onChange={(item) => {
              setFilter({ ...filter, mes: item.value });
            }}
          />
        </div>

        <div className="col-lg-2">
          <label>Ano</label>
          <Select
            className="select-form-control"
            value={lib.selectListAnos?.find((item) => item.value === filter.ano)}
            options={lib.selectListAnos}
            isClearable={false}
            onChange={(item) => {
              setFilter({ ...filter, ano: item.value });
            }}
          />
        </div>

        <div className="col row">
          <div className="col-xl-6"></div>

          <div className="col-xl-3 col-6 align-content-end">
            {/* Botão Exportar --------------------------------------------------------------------- */}
            <button
              type="button"
              className="btn btn-secondary btn-sm btn-action"
              onClick={() => {
                setFilter({
                  ...filter
                });
                getExtratoRankingVendedoresVolume();
              }}
              disabled={isLoading}
            >
              <FontAwesomeIcon icon={faFileExcel} /> Exportar
            </button>
          </div>

          <div className="col-xl-3 col-6 align-content-end">
            <button
              type="button"
              className="btn btn-secondary btn-sm btn-action"
              onClick={() => {
                setFilter({
                  ...filter
                  //pageNumber: 1
                });
                getRankingVendedoresVolume();
              }}
              disabled={isLoading}
            >
              <FontAwesomeIcon icon={faFilter} /> Filtrar
            </button>
          </div>
        </div>
      </div>

      {/* Lista Representadas ----------------------------------------------------------------- */}
      <div className="table-responsive table-historico mt-4" onCopy={(e) => lib.parseCopiedText(e)}>
        {!isLoading && vendedores ? (
          <Table striped bordered hover width="100%" className="table-relatorio">
            <thead>
              <tr>
                <th>Vendedor</th>
                <th>Ano Anterior</th>
                <th>Mês Anterior</th>
                <th>Média 12M</th>
                <th>Máx (12 meses)</th>
                <th>Faturado</th>
                <th>Objetivo</th>
                <th colSpan={2} className="text-center">
                  Realizado
                </th>
              </tr>
            </thead>
            <tbody>
              {vendedores.length > 0 ? (
                ([...vendedores, ...totalVendedores] || [])?.map((item, index) => (
                  <tr key={index} className={index >= vendedores.length ? 'fw-700' : ''}>
                    <td>{item.nome}</td>
                    <td>{lib.formatToNumeric(item.volumeAnoAnterior, 3, true)} Kg</td>
                    <td>{lib.formatToNumeric(item.volumeMesAnterior, 3, true)} Kg</td>
                    <td>{lib.formatToNumeric(item.volumeMediaAnual, 3, true)} Kg</td>
                    <td>{lib.formatToNumeric(item.volumeMaximoMensal, 3, true)} Kg</td>
                    <td>{lib.formatToNumeric(item.volumeFaturado, 3, true)} Kg</td>
                    <td>{lib.formatToNumeric(item.volumeMeta, 3, true)} Kg</td>
                    <td className={item.volumeRealizado < 0 ? 'txt-red' : 'txt-green'}>
                      {item.volumeMeta > 0 ? lib.formatToNumeric(item.volumeRealizado, 3, true) : 0}{' '}
                      Kg
                    </td>
                    <td
                      style={{ textAlign: 'center' }}
                      className={
                        item.porcentagemRealizado < 100 && item.volumeMeta != 0
                          ? 'txt-red'
                          : 'txt-green'
                      }
                    >
                      {lib.formatToNumeric(item.porcentagemRealizado, 2, true)}%
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={9}>Nenhum registro encontrado.</td>
                </tr>
              )}
            </tbody>
          </Table>
        ) : (
          <Skeleton count={10} />
        )}
      </div>
    </div>
  );
}
